import { BoundPictureListEditor } from "lib/@components/document-viewer/picture-list-editor"

export function Pictures() {
    return <BoundPictureListEditor field="pictures" default={[]} />
}
